import React from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import { H2 } from 'components/common/Text/Text'
import Mixin from 'components/common/Mixin'
import Media from 'components/common/Media'
import Theme from 'components/common/Theme/Theme'
import RoundIcon from 'components/common/RoundIcon/RoundIcon'

const Heading = ({ asset, className, title, subhead, targetId, ...props }) =>
  <HeadWrapper className={ className } { ...props } >
    { asset &&
      <Logo medium inline asset={ asset } />
    }
    <Headline id={ targetId } headline inline noMargin tabIndex="-1">{ title }</Headline>
    <SubHead data-non-empty>{ subhead }</SubHead>
  </HeadWrapper>

Heading.propTypes = {
  asset: PropTypes.string,
  className: PropTypes.string,
  subhead: PropTypes.string,
  tagName: PropTypes.string,
  targetId: PropTypes.string,
  title: PropTypes.string
}

export default Heading

const HeadWrapper = styled.div`
  text-align: center;
  ${Mixin.responsive('margin-bottom', '40px', '20px')}
  ${props => props.left && css`
    ${Media.desktop`
      text-align: left;
    `}
  `}
`

const Headline = styled(H2)`
  ${Mixin.responsive('line-height', '56px', '30px')}
  ${Media.mobile`
    font-size: 20px;
  `}
`

const SubHead = styled.div`
  margin: 15px 0 0;
  line-height: 22px;
  color: ${Theme.colors.dark_grey};
`

const Logo = styled(RoundIcon)`
  vertical-align: middle;
  ${Mixin.responsive('margin-right', '15px', '10px')}
`
